import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Group,
  Inject,
} from '@syncfusion/ej2-react-grids';
import {
  Edit,
  Toolbar,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  Resize,
} from '@syncfusion/ej2-react-grids';
import moment from 'moment';
import React, { Component } from 'react';
import { FcFilledFilter } from 'react-icons/fc';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { RiFilterFill, RiFilterOffFill } from 'react-icons/ri';
import AssetsIntelligenceServices from '../../services/AssetsIntelligence/AssetsIntelligenceServices';
import Message from '../../utils/Message/Message';
import './style.css';
import { all_information } from '../../App';

interface IState {
  assets_data: Array<any>;
}
interface IProps {}
export default class AssetRegistration extends Component<IProps, IState> {
  private assetsIntelligenceServices = new AssetsIntelligenceServices();
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: false,
  };
  public toolbarOptions: any = ['Add', 'Edit', 'Delete', 'Update', 'Cancel'];
  format = { type: 'dateTime', format: 'D/m/y hh:mm a' };
  public editSettings: any = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    newRowPosition: 'Top',
  };
  private grid: any;
  private isEdit = false;
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      assets_data: [],
    };
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      //   this.setState({ hideDialog: true, firstName: '', lastName: '' });
    }
  }
  componentDidMount() {
    let args: any={
      startIndex: Number,
      endIndex: Number,
    }
    this.assetsIntelligenceServices
      .getAssets("500")
      .then((el) => {
        el.data.map((res: any) => {
          res.valid_date = this.ConvertToDate(res.valid_date);
        });
        this.setState({ assets_data: el.data });
      })
      .catch((er) => {
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  filterHightUp() {
    $('.filter-page').css({
      height: '260px',
    });
    $('.hideUp').hide();
    $('.hideDown').show();
  }
  filterHightDown() {
    $('.hideUp').show();
    $('.hideDown').hide();
    $('.filter-page').css({
      height: '100px',
    });
  }
  ConvertToDate(val: any) {
    if (val === null || val === '') {
      return '';
    }
    var num = parseInt(val?.substring(6, 19));
    var date = new Date(num);
    var result = moment(date).format('');
    return result;
  }
  actionBegin(args: any): void {
    if (args.requestType === 'save') {
      if (
        this.grid.pageSettings.currentPage !== 1 &&
        this.grid.editSettings.newRowPosition === 'Top'
      ) {
        args.index =
          this.grid.pageSettings.currentPage * this.grid.pageSettings.pageSize -
          this.grid.pageSettings.pageSize;
      } else if (this.grid.editSettings.newRowPosition === 'Bottom') {
        args.index =
          this.grid.pageSettings.currentPage * this.grid.pageSettings.pageSize -
          1;
      }
      var theObj = {
        asset_id: args.data.asset_id,
        app: 'UWORK',
        user_id: all_information.user_id,
        organization_id: all_information.company_id?.toString(),
        asset_description: args.data.asset_description,
        serial_number: args.data.serial_number,
        asset_supplier: args.data.asset_supplier,
        asset_manufacturer: args.data.asset_manufacturer,
        asset_type_code1: args.data.asset_type_code1,
        asset_type_code2: args.data.asset_type_code2,
        asset_type_code3: args.data.asset_type_code3,
        asset_type_code4: args.data.asset_type_code4,
        valid_date: `/Date(${moment(args.data.valid_date).valueOf()}-0500)/`,
      };
      if (this.isEdit) {
        this.assetsIntelligenceServices
          .EditAssets(theObj)
          .then((el) => {
            Message.success('Success');
          })
          .catch((er) => {
            //(er);
            Message.error('Error occured while updated data');
            args.cancel = true;
            if (er.response) {
              Message.error(er.response.data);
              Message.error(er.response.status);
              Message.error(er.response.headers);
            } else if (er.request) {
              Message.error(er.request);
            } else {
              Message.error('Error: ' + er.message);
            }
            Message.error(er.config);
          });
      } else {
        this.assetsIntelligenceServices
          .AddAssets(theObj)
          .then((el) => {
            Message.success('Success');
          })
          .catch((er) => {
            //(er);
            Message.error('Error occured while added data');
            args.cancel = true;
            if (er.response) {
              Message.error(er.response.data);
              Message.error(er.response.status);
              Message.error(er.response.headers);
            } else if (er.request) {
              Message.error(er.request);
            } else {
              Message.error('Error: ' + er.message);
            }
            Message.error(er.config);
          });
      }
    }
    if (args.requestType === 'beginEdit') {
      this.isEdit = true;
    }
    if (args.requestType === 'add') {
      this.isEdit = false;
    }
    if (args.requestType === 'delete') {
      var theObj = {
        asset_id: args.data.asset_id,
        app: 'UWORK',
        user_id: all_information.user_id,
        organization_id: all_information.company_id?.toString(),
        asset_description: args.data.asset_description,
        serial_number: args.data.serial_number,
        asset_supplier: args.data.asset_supplier,
        asset_manufacturer: args.data.asset_manufacturer,
        asset_type_code1: args.data.asset_type_code1,
        asset_type_code2: args.data.asset_type_code2,
        asset_type_code3: args.data.asset_type_code3,
        asset_type_code4: args.data.asset_type_code4,
        valid_date: `/Date(${moment(args.data.valid_date).valueOf()}-0500)/`,
      };
      this.assetsIntelligenceServices
        .DeleteAssets(theObj)
        .then((el) => {
          //(el.data.Messages[0]);

          Message.success('Success');
        })
        .catch((er) => {
          //(er);
          Message.error('Error occured while delete data');
          args.cancel = true;
          if (er.response) {
            Message.error(
              er.response.data +
                '\n' +
                er.response.status +
                '\n' +
                er.response.headers
            );
          } else if (er.request) {
            Message.error(er.request);
          } else {
            Message.error('Error: ' + er.message);
          }
          Message.error(er.config);
        });
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          dataSource={this.state.assets_data}
          editSettings={this.editSettings}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.grid = g)}
          height='calc(-220px + 100vh)'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          toolbarClick={this.toolbarClick.bind(this)}
          gridLines={'Both'}
          actionBegin={this.actionBegin.bind(this)}
          // queryCellInfo={this.cellRender}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='assetId'
              headerText='Asset ID'
              textAlign='Left'
              isPrimaryKey
              validationRules={{ required: true, number: true }}
              autoFit
            />
            <ColumnDirective
              field='parentAssetCode'
              headerText='Parent Asset'
              textAlign='Left'
            />
            <ColumnDirective
              field='parent_project'
              headerText='Parent Project'
              textAlign='Left'
            />
            <ColumnDirective
              field='assetCode'
              headerText='Asset Number'
              textAlign='Left'
            />
            <ColumnDirective
              field='assetDescription'
              headerText='Description'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='asset_type_code1'
              headerText='Asset Info 1'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='asset_type_code2'
              headerText='Asset Info 2'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='asset_type_code3'
              headerText='Asset Info 3'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='asset_type_code4'
              headerText='Asset Info 4'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='serial_number'
              headerText='Serial Number'
              textAlign='Left'
              validationRules={{ required: true }}
            />

            <ColumnDirective
              field='asset_branch'
              headerText='Asset Branch'
              textAlign='Left'
            />

            <ColumnDirective
              field='assetModel'
              headerText='Model'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='asset_supplier'
              headerText='Supplier'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='assetManufacturer'
              headerText='Manufacturer'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='statusCode'
              headerText='Status'
              textAlign='Left'
              validationRules={{ required: true }}
            />
            <ColumnDirective
              field='assetTypeCode'
              headerText='Type'
              textAlign='Left'
            />
            {/* <ColumnDirective
              field='asset_type_code'
              headerText='Type'
              textAlign='Left'
            /> */}
            <ColumnDirective
              field='assetDepartment'
              headerText='Department'
              textAlign='Left'
            />
            <ColumnDirective
              field='assetLocateCode'
              headerText='Location'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_install_date'
              headerText='Install Date'
              textAlign='Left'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='approval_code'
              headerText='Approval Code'
              textAlign='Left'
            />
            <ColumnDirective
              field='approval_number'
              headerText='Approval Number'
              textAlign='Left'
            />
            <ColumnDirective
              field='validDate'
              headerText='Valid Date'
              // format={this.format}
              textAlign='Left'
              editType='datetimepickeredit'
            />
            <ColumnDirective
              field='asset_target_mtbf'
              headerText='Target MTBF'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_change_cost'
              headerText='Change out Costs'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_capital_cost'
              headerText='Capital Costs'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_mat_cost'
              headerText='Material Costs'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_total_cost'
              headerText='Total Costs'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_other_cost'
              headerText='Other Costs'
              textAlign='Left'
            />
            <ColumnDirective
              field='lastUpdateDate'
              headerText='Last Update'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_usage_uom'
              headerText='Usage UOM'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_production_uom'
              headerText='Production UOM'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_avg_week_usage'
              headerText='Weekly Avg Usage'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_last_fail_Date'
              headerText='Last Fail Date'
              textAlign='Left'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='asset_total_failures'
              headerText='Total Failures'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_bom'
              headerText='Asset BOM Number'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_condition'
              headerText='Condition'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_warranty_dt'
              headerText='Warranty Date'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_warranty_dt'
              headerText='Warranty Date'
              textAlign='Left'
            />
            <ColumnDirective
              field='component_tracking'
              headerText='Tracking'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_exp_life'
              headerText='Expected Life'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_exp_life'
              headerText='Expected Life'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_war_life'
              headerText='Warranty Life'
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[Edit, Toolbar, Filter, Page, ColumnMenu, Resize, Group]}
          />
        </GridComponent>
        
        <div className='filter-page'>
          <div className='filter-child'>
            <div className='filter-icon'>
              <div className='first-icon'>
                <FcFilledFilter size={20} />
                Filter
              </div>
              <div className='second-icon'>
                <div className='hideUp'>
                  <IoIosArrowUp
                    onClick={this.filterHightUp.bind(this)}
                    size={20}
                  />
                </div>
                <div className='hideDown'>
                  <IoIosArrowDown
                    onClick={this.filterHightDown.bind(this)}
                    size={20}
                  />
                </div>
              </div>
            </div>
            <div className='filter-content'>
              <div className='filter-body'>
                <div
                  className='row mb-3'
                  style={{ flexDirection: 'row' }}
                ></div>
                <div className='filter-footer'>
                  <div
                    className='btn-filter w-100'
                    //   onClick={this.FilterFonkScheduler.bind(this)}
                  >
                    <span>
                      <RiFilterFill size={15} color='#f7b731' />
                    </span>
                    <span>Apply filter</span>
                  </div>
                  <div
                    className='btn-clear-filter  w-100'
                    //   onClick={this.clearFilter.bind(this)}
                  >
                    <span>
                      <RiFilterOffFill size={15} color='red' />
                    </span>
                    <span>Clear filter</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
